import React from 'react'
import intl from 'react-intl-universal'
import Lightbox from 'react-simple-lightbox'
import { connect } from 'react-redux'
import { ReactComponent as SmallCheck } from '../assets/icons/check.svg'

const mapStateToProps = state => ({
  group_treshold: state.config.group_treshold || 10,
  show_corrected_price: state.config.show_corrected_price || false,
  show_barcode_in_packing_zone: state.config.show_barcode_in_packing_zone || false,
  lang: state.auth.lang
})

class ProductListItemComponent extends React.Component {
  constructor(props) {
    super(props)
    const { group_treshold, show_corrected_price, product, parent, childIndex, savedDraft } = props
    const qty = product.quantity
    parent.lines[childIndex] = this
    const draft = savedDraft && savedDraft.quantity === product.quantity ? savedDraft : null
    this.state = {
      decision: draft ? draft.decision : {},
      action: draft ? draft.action : {},
      checked: {},
      correctedPrices: draft ? draft.correctedPrices : (product.quantity % 1 === 0 ? Array(product.quantity).fill(product.corrected_price || 0) : [product.corrected_price || 0]),
      show_corrected_price: show_corrected_price,
      expand: (qty >= group_treshold) ? false : true
    }
  }

  getDraft = () => {
    const { product } = this.props
    const { decision, action, correctedPrices } = this.state
    const toObject = (values) => Object.keys(values || {}).reduce((res, key) => {
      if (values[key] !== undefined && values[key] !== null) {
        res[key] = values[key]
      }
      return res
    }, {})
    return {
      quantity: product.quantity,
      decision: toObject(decision),
      action: toObject(action),
      correctedPrices: Array.from(correctedPrices || [], (price) => (price === undefined || price === null ? '' : price)),
    }
  }

  getActionRadio = (opt, key, action)=>{
    return (<label htmlFor={`actions_${key}_${opt[0]}`}
             key={`actions_${key}_${opt[0]}`}>
      <input type="radio"
             name={`actions_${key}`}
             id={`actions_${key}_${opt[0]}`}
             data-index={(''+key).split('.').slice(-1)[0]}
             onChange={this.actionChange}
             checked={action === (''+opt[0])}
             value={opt[0]}/>
      <div className="check">
        <div className="check-icon">
          <SmallCheck/>
        </div>
        {opt[1]}
      </div>
    </label>)
  }

  toggleExpand = ()=>{
    const { expand } = this.state
    this.setState({
      expand: !expand
    })
  }

  checkboxClick = (e) => {
    const { checked, expand } = this.state
    const { product, parent } = this.props
    let new_checked
    const $checkbox = e.currentTarget.children[0]
    const value = !$checkbox.classList.contains('checked')
    if(expand){
      const index = parseInt(e.currentTarget.dataset.index)
      new_checked = {
        ...checked,
        [index]: value
      }
    } else {
      new_checked = product.quantity % 1 === 0 ? Array(product.quantity).fill(value) : [value]
    }
    this.setState({
      checked: new_checked,
    }, () => {
      parent.toggleConfirmButton()
    })
  }

  decisionChange = (e)=>{
    const { decision, action, expand } = this.state
    const { product, parent } = this.props
    let new_decision, new_action
    if(expand && product.quantity % 1 === 0){
      const index = parseInt(e.currentTarget.dataset.index)
      new_decision = {
        ...decision,
        [index]: e.currentTarget.value
      }
      new_action = {
        ...action
        // Don't reset action when changing decision
      }
    } else {
      if(product.quantity % 1 === 0) {
        new_decision = Array(product.quantity).fill(e.currentTarget.value)
        new_action = Array(product.quantity).fill(undefined)
      } else {
        new_decision = [e.currentTarget.value]
        new_action = [undefined]
      }
    }
    this.setState({
      decision: new_decision,
      action: new_action
    }, () => {
      parent.toggleConfirmButton()
    })
  }

  markAsValidByScan = () => {
    const { product, parent } = this.props
    const { decision, action } = this.state
    const qty = product.quantity % 1 === 0 ? product.quantity : 1

    const decisions = [...Array(qty).keys()].map((index) => decision[index])
    const allValid = decisions.every((itemDecision) => itemDecision === '0')
    if (allValid) {
      return 'already_valid'
    }

    let targetIndex = decisions.findIndex(
      (itemDecision) => typeof itemDecision === 'undefined' || itemDecision === false
    )
    let changedFromOtherStatus = false
    if (targetIndex < 0) {
      targetIndex = decisions.findIndex((itemDecision) => itemDecision !== '0')
      changedFromOtherStatus = true
    }
    if (targetIndex < 0) {
      return 'already_valid'
    }

    const new_decision = {
      ...decision,
      [targetIndex]: '0'
    }
    const new_action = {
      ...action,
      [targetIndex]: undefined
    }

    this.setState({
      decision: new_decision,
      action: new_action
    }, () => {
      parent.toggleConfirmButton()
    })

    return changedFromOtherStatus ? 'status_changed' : 'marked_valid'
  }

  // Extract numeric value from price string (e.g. "10,00 zł" -> "10,00")
  extractNumericPrice = (priceStr) => {
    if (!priceStr) return ''
    // Match number with optional decimal (comma or dot)
    const match = priceStr.toString().match(/[\d]+[,.]?[\d]*/)
    return match ? match[0] : ''
  }

  actionChange = (e)=>{
    const { action, expand, correctedPrices } = this.state
    const { product, parent } = this.props
    let new_action
    let new_correctedPrices = [...correctedPrices]
    const selectedActionId = parseInt(e.currentTarget.value)
    
    // Check if selected action has korekta kwotowa flag (opt[3] === true)
    const selectedOption = product.approve_options.find(opt => opt[0] === selectedActionId)
    const isKorektaKwotowa = selectedOption && selectedOption[3] === true
    // After a previous correction only the corrected price is left to refund
    const numericPrice = this.extractNumericPrice(
      product.price_unit_corrected || product.price_unit)
    
    if(expand && product.quantity % 1 === 0){
      const index = parseInt(e.currentTarget.dataset.index)
      new_action = {
        ...action,
        [index]: e.currentTarget.value
      }
      // Auto-fill price_unit only for this specific item when korekta kwotowa is selected
      if(isKorektaKwotowa) {
        new_correctedPrices[index] = numericPrice
      }
    } else {
      // Collapsed view - action applies to all quantities
      if(product.quantity % 1 === 0) {
        new_action = Array(product.quantity).fill(e.currentTarget.value)
        // Auto-fill all positions with price_unit (they share one input field)
        if(isKorektaKwotowa) {
          new_correctedPrices = Array(product.quantity).fill(numericPrice)
        }
      } else {
        new_action = [e.currentTarget.value]
        if(isKorektaKwotowa) {
          new_correctedPrices = [numericPrice]
        }
      }
    }
    this.setState({
      action: new_action,
      correctedPrices: new_correctedPrices
    }, () => {
      parent.toggleConfirmButton()
    })
  }

  changeCorrectedPrice = (e, index) => {
    const { product, parent } = this.props;
    const value = e.target.value;
    
    // Use the passed index parameter, or 0 if undefined (for non-integer quantities)
    const actualIndex = typeof index !== 'undefined' ? index : 0;
  
    const isValidInput = /^-?\d*[.,]?\d*$/.test(value);
  
    if (!isValidInput) {
      return;
    }
  
    const formattedValue = value.replace('.', ',');
  
    const newCorrectedPrices = [...this.state.correctedPrices];
    newCorrectedPrices[actualIndex] = formattedValue;
  
    this.setState({
      correctedPrices: newCorrectedPrices,
    }, () => {
      parent.toggleConfirmButton();
    });
  };

  renderItem(product, index){
    const { decision, action } = this.state
    const { show_corrected_price, show_barcode_in_packing_zone } = this.props
    let key = product.id || product.sale_order_line_id
    let item_decision = decision[0]
    let item_action = action[0]
    let actualIndex = 0
    if(typeof index !== 'undefined'){
      key = product.id+'.'+index
      item_decision = decision[index]
      item_action = action[index]
      actualIndex = index
    }
    const odoo = window.ODOO.url + (window.ODOO.port?':'+window.ODOO.port:'')+'/product/image?default_code='
    return(
      <div key={key}>
        <div className="product_leftcol">
          <Lightbox>
            <img src={odoo+product.default_code} alt="product"/>
          </Lightbox>
        </div>
        <div className="product_details">
          <h4>
            {product.name}
              <span className='product_details__codes'>
                {product.default_code &&
                  <div className="default_code" data-code={product.default_code}><label>SKU:</label> [{product.default_code}]</div>
                }
                {show_barcode_in_packing_zone && product.barcode &&
                  <div className="product_details__barcode"><label>EAN:</label> [{product.barcode}]</div>
                }
              </span>
          </h4>

          <div className="price f_group">
            <label>{intl.get('Cena jednostkowa')}:</label>
            <div><b>{product.price_unit}</b></div>
          </div>

          {product.price_unit_corrected && (
            <div className="price price_corrected f_group">
              <label>{intl.get('Cena jednostkowa po korekcie')}:</label>
              <div><b>{product.price_unit_corrected}</b></div>
            </div>
          )}

          {product.quantity > 1 && (
            <div className="qty f_group">
              <label>{intl.get('Ilość')}:</label>
              <div>{product.quantity}</div>
            </div>
          )}
  
          {(product.reason || product.integration_reason) && (
            <div className="request f_group">
              <label>{intl.get('Przyczyna')}:</label>
              <div>{product.reason || product.integration_reason || ''}</div>
            </div>
          )}

          {(product.expectations) && (
            <div className="request f_group">
              <label>{intl.get('Oczekiwania')}:</label>
              <div>{product.expectations || ''}</div>
            </div>
          )}

          {(
            product.id < 0 ||
            (
              show_corrected_price &&
              item_decision === '0' &&
              product.type === 'service' &&
              product.ship_line &&
              product.approve_options.some((opt) => opt[2] === true) &&
              item_action &&
              product.approve_options.find(
                (opt) => opt[0] === parseInt(item_action) && opt[2] === true
              )
            ) ||
            (
              item_decision === '0' &&
              item_action &&
              product.approve_options.find(
                (opt) => opt[0] === parseInt(item_action) && opt[3] === true
              )
            )
          ) && (
            <div className="price f_group relative corrected-price__wrapper">
              <label>
                {product.approve_options.find(
                  (opt) => opt[0] === parseInt(item_action) && opt[3] === true
                ) ? intl.get('Kwota zwrotu') : intl.get('Cena skorygowana')}
              </label>
              <input
                type="text"
                inputMode="decimal"
                value={this.state.correctedPrices[actualIndex] || ""}
                onChange={(e) => this.changeCorrectedPrice(e, index)}
              />
              <span className="currency">{product.currency_symbol}</span>
            </div>
          )}

          {product.product_note && (
            <div className="notes f_group full_width">
              <label>{intl.get('Notatki')}:</label>
              <div style={{'paddingLeft': '32px'}}>
                <span>{product.product_note}</span>
              </div>
            </div>
          )}
  
          {product.recent_bundle_products && (
            <div className="bundleWrapper">
              <table>
                <tbody>
                  {Object.values(product.recent_bundle_products).map((item, index) => (
                    <tr key={index}>
                      <td>{item.name}</td>
                      <td>{item.qty_uom} szt.</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
  
          <div className="actions" data-decision={item_decision}>
            <div className="actions_0">
              {product.approve_options.map((opt)=>this.getActionRadio(opt, key, item_action))}
            </div>
            <div className="actions_1">
              {product.decline_options.map((opt)=>this.getActionRadio(opt, key, item_action))}
            </div>
          </div>
        </div>
  
        <div className="product_decision" data-line={key}>
          <label htmlFor={`decision_${key}_0`}>
            <input
              type="radio"
              name={`decision_${key}`}
              id={`decision_${key}_0`}
              data-index={index}
              onChange={this.decisionChange}
              checked={item_decision === '0'}
              value="0"/>
            <div className="check"></div>
            {intl.get('Zasadna')}
          </label>

          <label htmlFor={`decision_${key}_1`}>
            <input
              type="radio"
              name={`decision_${key}`}
              id={`decision_${key}_1`}
              data-index={index}
              onChange={this.decisionChange}
              checked={item_decision === '1'}
              value="1"/>
            <div className="check"></div>
            {intl.get('Niezasadna')}
          </label>
  
          <label htmlFor={`decision_${key}_2`}>
            <input
              type="radio"
              name={`decision_${key}`}
              id={`decision_${key}_2`}
              data-index={index}
              onChange={this.decisionChange}
              checked={item_decision === '2'}
              value="2"/>
            <div className="check"></div>
            {intl.get('Brak w paczce')}
          </label>
        </div>
      </div>
    )
  }

  render() {
    const { group_treshold, product } = this.props
    const { expand } = this.state
    const qty = product.quantity
    const lineIndex = this.props.childIndex
    let className = `ramka produkt ${expand ? 'expanded' : ''} ${product.previously_returned ? 'previously-returned' : ''}`
    return (
      <div className={className} data-line-index={lineIndex}>
        { (!expand || product.quantity % 1 !== 0) &&
          this.renderItem(product)
        }
        { expand && (product.quantity % 1 === 0) &&
          [...Array(product.quantity).keys()].map((k) => {
            return this.renderItem(
              {
                ...product,
                quantity: 1,
              }, k
            )
          })
        }
        {(qty >= group_treshold) && (qty % 1 === 0) && 
          <button className="expander" title={intl.get('Rozwiń')} onClick={this.toggleExpand}>• • •</button>
        }
      </div>
    )
  }
}

const ProductListItem = connect(mapStateToProps)(ProductListItemComponent)
export default ProductListItem
